import api from "../../../utils/api";

export const countryLocationsMap = ({ maps, mapStyles, mapTarget }) => {
    const map = new maps.Map(mapTarget, {
        zoom: 1,
        center: { lat: 0, lng: 0 },
        mapTypeControl: false,
        styles: mapStyles,
    });

    return map;
};

export function fetchCountryLocationsData({ fetchUrl }) {
    this.sliderReady = false;
    this.noResults = false;
    try {
        api(fetchUrl)
            .then((response: any) => {
                if (response.location.length === 0) {
                    this.noResults = true;
                }
                this.apiResponse = response;
            })
            .catch(() => {
                this.error = true;
            });
    } catch (e) {
        this.error = true;
    }
}
